<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Lfg7NA/tc-custom/FC-9781528968287.jpg?1684515194351?1709062081852" alt="This image is the cover for the book The Shrinking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Shrinking
      </h1>
      <p class="bookDescription body article font2">
        <p>This is a story set in 1954, a year after the coronation of Queen Elizabeth II. It's spring time in a suburban area of 'The Big City'. There is a mysterious wood, a secret camping expedition, a graveyard, wildlife-rich ponds and pea-soup fogs. Three creative children with unusual families are targeted by a strange force, which causes them to gradually shrink. Eventually, they are the size of dust particles as they come face to face with earthly monsters and an alien species. This nightmare scenario forces them into many dangerous adventures and their problems are not solved until the very last chapter. Even then there are questions. Will they grow back normally? How will they react to fame? How will they be treated at school? The psychiatrist, Henry Osman, will have to play a big part in their rehabilitation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Colin Graham
      </h2>
      
      <p class="authorDescription body article">Professionally, Colin Graham has been a teacher, a head teacher, a part-time lecturer in teacher training and a field teacher for the RSPB. During that time, he told this story to many groups of children who always appeared transfixed by each instalment. Their empathy with miniaturised children was always apparent, so he finally decided to put The Shrinking into writing. Colin is now a trustee of The Barnsley Biodiversity Trust and project leader of Biodiversity in Schools. He visits schools on a regular basis and his knowledge of and empathy with children is vast. His wildlife knowledge is also formidable.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9199a266